module.exports = __webpack_public_path__ + "img/check-w.38400522.svg";